import { useGetUsersQuery } from '@klp/prosjekt/services/rtkApi';
import { useCallback } from 'react';
import { getBrukerDisplayName } from '@klp/user/utils';

export const useMapEmailToUser = () => {
    const { data, isLoading, isFetching } = useGetUsersQuery();

    const handleMapping = useCallback(
        (email?: string | null) => {
            if (!email) {
                return '';
            }
            const user = data?.find((u) => u?.brukerId === email);

            if (user) {
                return getBrukerDisplayName(user.fulltnavn, user.epost, email);
            }

            return email;
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [isLoading, isFetching, data],
    );

    return { handleMapping };
};
